import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// i18n
// Ready translated locale messages
import en from "@/locales/i18n/en_US";
import cn from "@/locales/i18n/zh_CN";
import bm from "@/locales/i18n/bm_MY";

const messages = {
    bm: bm,
    en: en,
    cn: cn
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "en",
    messages, // set locale messages
});

export default i18n;


// WEBPACK FOOTER //
// ./src/locales/i18n/i18n.js